import React from 'react';
import Button from 'jsx/elements/buttons/Button';

import useLocale from 'jsx/locale/useLocale';
import './Comments.less';

export const Comments = ({ comments, onChange }) => {
  // const { t } = useLocale();
  // const { user } = useAuthContext();
  const [data, setData] = React.useState(null);

  return (
    <>
      <div className="grid">
        <div className="col s1of1" style={{ paddingBottom: 30 }}>
          <div style={{ paddingBottom: 15 }}>
            <label>Athugasemd</label>
          </div>
          <div className="comment-field">
            <textarea
              onChange={e => onChange(e)}
              value={comments}
              placeholder={''}
              style={{ resize: 'none' }}
              // disabled={props.loading}
            />
          </div>
        </div>
      </div>
    </>
  );
};
